var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_event_form_editTitle")
        : _vm.$t("label_essweb_event_form_viewTitle"),
      widthClass: "max-1000",
      editBtn: !_vm.iSEdited && _vm.hasBtn("edit-admin-event-management"),
      pad: "0",
      delBtn: _vm.hasBtn("delete-admin-event-management"),
      initData: _vm.eventData,
      checkData: [
        "event_business_name",
        "event_business_code",
        "event_business_description",
        "start_utc_time",
        "end_utc_time",
        "event_type_uuid",
        "event_property_group_uuid",
        "remarks",
      ],
    },
    on: {
      edit: function ($event) {
        _vm.iSEdited = true
      },
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_event_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: { curTab: _vm.curTab, items: _vm.taber },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "start" } },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_event_list_eventTypeLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.EventType,
                                      "item-text": "event_type_name",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      "item-value": "uuid",
                                      disabled: true,
                                      "single-line": "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      label: _vm.$t(
                                        "label_essweb_event_list_eventTypeLabel"
                                      ),
                                      dense: "",
                                    },
                                    on: { change: _vm.onTypeChange },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.eventData.event_type_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventData,
                                          "event_type_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "eventData.event_type_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "100",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.eventData.event_business_name,
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.eventData.event_business_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      maxlength: "20",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimReason_form_codeLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.eventData.event_business_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventData,
                                          "event_business_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "eventData.event_business_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.eventData
                                          .event_business_description,
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventDescriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.eventData.event_business_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("TimePicker", {
                                    attrs: {
                                      isRequire: "",
                                      showDay: "",
                                      max: _vm.eventData.end_utc_time,
                                      value: _vm.eventData.start_utc_time,
                                      defaultTime: _vm.eventData.start_utc_time,
                                      disable: !_vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventStartTimeLbel"
                                      ),
                                      placeholder: "--:--",
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.eventData.start_utc_time = time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("TimePicker", {
                                    attrs: {
                                      isRequire: "",
                                      isEnd: "",
                                      showDay: "",
                                      min: _vm.eventData.start_utc_time,
                                      value: _vm.eventData.end_utc_time,
                                      defaultTime: _vm.eventData.end_utc_time,
                                      placeholder: "--:--",
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventEndTimeLabel"
                                      ),
                                      disable: !_vm.iSEdited,
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.eventData.end_utc_time = time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-n5",
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_event_form_timeZoneLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.staticZone,
                                      "item-text": "text",
                                      "item-value": "utc",
                                      dense: "",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      placeholder: _vm.$t(
                                        "label_essweb_event_form_timeZoneLabel"
                                      ),
                                      filled: _vm.iSEdited,
                                      "single-line": "",
                                      readonly: !_vm.iSEdited,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.eventData.end_time_time_zone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventData,
                                          "end_time_time_zone",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "eventData.end_time_time_zone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form2" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                    "offset-md": "0",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_event_form_eventPropertyGroupLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.EventGroup,
                                      "item-text": "event_property_group_name",
                                      "item-value": "uuid",
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      filled: _vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      "single-line": "",
                                      readonly: !_vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_event_form_eventPropertyGroupLabel"
                                      ),
                                      dense: "",
                                    },
                                    on: { change: _vm.onGroupChange },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.eventData.event_property_group_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventData,
                                          "event_property_group_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "eventData.event_property_group_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _vm.desserts.length
                                    ? _c("PropertyList", {
                                        attrs: {
                                          items: _vm.desserts,
                                          listdata: _vm.PropertyListData,
                                          canEdit: false,
                                        },
                                        on: {
                                          view: function (obj) {
                                            _vm.viewProperty = true
                                            _vm.toEditProperty(obj)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: _vm.curTab == "tab-1" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("EditMappingPopup2", {
              attrs: {
                show: _vm.showMappingPopup,
                PropertyData: _vm.PropertyData,
                curGroupId: _vm.eventData.event_property_group_uuid,
                view: _vm.viewProperty,
              },
              on: {
                close: function ($event) {
                  _vm.showMappingPopup = false
                  _vm.PropertyData = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }